export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7115.eb9828d7.jpg";